
<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="bahanbangunans">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData" v-can="'A'">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ bahanbangunans.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : bahanbangunans.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="bahanbangunan">Bahan Bangunan</vs-th>
        <vs-th sort-key="harga">Harga</vs-th>
        <vs-th v-can="'E'">Edit</vs-th>
        <vs-th v-can="'D'">Delete</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.harga | currency }} / {{ tr.namasatuan }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" v-can="'E'"/>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteConfirm(tr.id, tr.name)" v-can="'D'"/>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>

    </vs-table>
    <vs-prompt
      color="danger"
      title="Konfirmasi"
      @accept="deleteData(hapusId, hapusBahanBangunan)"
      @close="close"
      :active.sync="hapus">
      <div class="con-exemple-prompt">
        Yakin ingin menghapus bahanbangunan {{ hapusBahanBangunan }}
      </div>
     </vs-prompt>
  </div>
</template>

<script>
import DataViewSidebar from './BahanBangunanSidebar.vue'
import bahanbangunanModule from '@/stores/term/bahanbangunan.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    DataViewSidebar
  },
  data () {
    return {
      selected: [],
      // bahanbangunans: [],
      itemsPerPage: 5,
      isMounted: false,
      Satuans: [],
      satuan: null,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      hapus: false,
      hapusId: null,
      hapusBahanBangunan: null,
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    bahanbangunans () {
      return this.$store.state.bahanbangunan.bahanbangunans
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.bahanbangunans.length
    },
    ...mapGetters({
      user : 'auth/user',
    }),
  },
  methods: {
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteConfirm(id, bahanbangunan){
      this.hapusId = id
      this.hapusBahanBangunan = bahanbangunan
      this.hapus = true
    },
    deleteData (id) {
      const obj = {
        id: id,
        taxonomy: 'bahan-bangunan'
      }
      this.$store.dispatch('bahanbangunan/removeBahanBangunan', obj)
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    close() {
      this.$emit('closed', false)
    },
    logout() {
      this.setAuth({}) 
      this.$router.push('/login').catch(() => {})
    }
  },
  created () {
    if (!bahanbangunanModule.isRegistered) {
      this.$store.registerModule('bahanbangunan', bahanbangunanModule)
      bahanbangunanModule.isRegistered = true
    }
    this.$store.dispatch('bahanbangunan/fetchBahanBangunan')

    let configs = {
      headers: {
        'Authorization': 'Bearer ' + this.user.api_token,
      },
    }
    this.axios.get('/term-list/satuan', configs)
    .then((response) => {
      let {data} = response.data
      this.Satuans = data
    })
    .catch((error) => {
      let data = error.data
      this.Satuans = data
    })

  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
